<div
  #dropdownNotifications="bs-dropdown"
  class="dropdown d-inline-block mx-3"
  dropdown
  [insideClick]="true"
  [isOpen]="false"
>
  <button
    type="button"
    class="btn header-item noti-icon"
    id="page-header-notifications-dropdown"
    dropdownToggle
  >
    <i class="bx bxs-bell"></i>
    <span class="badge bg-danger rounded-pill" *ngIf="unreadTotal$ | async as total">
      {{ total }}
    </span>
  </button>
  <div
    class="notifications-panel dropdown-menu dropdown-mega-menu-xl dropdown-menu-end p-0"
    aria-labelledby="page-header-notifications-dropdown"
    *dropdownMenu
  >
    <div class="card h-100 m-0">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col">
            <h6 class="m-0">Notifications</h6>
          </div>
          <div class="col-auto">
            <button type="button" class="btn btn-sm p-2" (click)="dropdownNotifications.hide()">
              <i class="bx bx-x font-size-24 lh-1"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="card-body d-flex flex-column justify-content-end">
        <ngx-simplebar class="overflow-x-hidden simplebar-notifications" #scrollRef>
          <div class="row">
            <div class="col-auto">
              <button
                type="button"
                class="btn"
                [ngClass]="{
                  'btn-primary': !onlyUnread,
                  'btn-soft-primary': onlyUnread,
                }"
                (click)="onlyUnread = false"
              >
                All Notifications
              </button>
            </div>
            <div class="col-auto">
              <button
                type="button"
                class="btn"
                [ngClass]="{
                  'btn-primary': onlyUnread,
                  'btn-soft-primary': !onlyUnread,
                }"
                (click)="onlyUnread = true"
              >
                Only Unread
              </button>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <div
                class="card border shadow-none mb-3"
                *ngFor="let item of getNotifications() | async | slice: 0 : 5"
              >
                <div class="card-body">
                  <div class="d-flex gap-2">
                    <span class="badge badge-soft-warning" *ngIf="!item.readInd"> Unread </span>
                    <span
                      class="badge bg-danger"
                      *ngIf="item.type === 'BROADCAST' && item.model?.priorityUrgentInd"
                    >
                      Urgent
                    </span>
                    <span class="badge badge-soft-primary" *ngIf="item.type === 'USER_EVENT'">
                      Custom Event
                    </span>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <ng-container *ngIf="item.type === 'BROADCAST'; else default">
                        <h5 class="fw-bolder">
                          {{ item.model?.priorityUrgentInd === true ? 'Urgent Broadcast' : 'Broadcast' }}
                        </h5>

                        <h6 class="text-primary">
                          {{ item.content.title }}
                        </h6>
                        <p class="col paragraph-truncate lines-2 m-0">
                          {{ item.content.body }}
                        </p>
                      </ng-container>

                      <ng-template #default>
                        <h5 class="fw-bolder">
                          {{ item.content.title }}
                        </h5>
                        <p class="col paragraph-truncate lines-2 m-0">
                          {{ item.content.body }}
                        </p>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ngx-simplebar>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col">
            <button
              class="btn btn-sm btn-primary font-size-14 text-center w-100"
              (click)="onNotifications()"
            >
              <i class="bx bx-chevron-right"></i>
              <span> Go to all Notifications </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
